module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAxklEQVQ4T63UuwrCQBCF4T+vpvgyCpa2am3pm1kEFEXxAuIDWMvALhxC9m6aNLNfssyZ6ch71q5smyrvUgWAYRtXtwT2sTMpULETMAFetWAxZh8K/WEVFgKrsTGwCRuCzZiCin2BeaqboU5bUxTLiGW8xEALrZ+Ev4CGKGpXXgDPGl1zqOjFTcW9FB0GW9GbQ68l6NikKPpw6DkXDY2eorYMpsAxB41tG0XfDu1TaGp9KfoBZsChdn35c4qugF0r6HOq76D5A+bAMpuOEbdCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1